"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Node_1 = require("./Node");
function createDefaultNode(sourceType) {
    const nodeType = sourceType.resolveDefinition();
    switch (nodeType.kind) {
        case "string":
            return new Node_1.PrimitiveNode(sourceType, nodeType, "");
        case "boolean":
            return new Node_1.PrimitiveNode(sourceType, nodeType, false);
        case "number":
            return new Node_1.PrimitiveNode(sourceType, nodeType, 0);
        case "literal":
            return new Node_1.PrimitiveNode(sourceType, nodeType, nodeType.value);
        case "array":
            return new Node_1.ArrayNode(sourceType, nodeType);
        case "object":
            const n = new Node_1.ObjectNode(sourceType, nodeType);
            for (const prop of Object.values(n.properties)) {
                if (!prop.propertyInfo.optional) {
                    prop.container.node = createDefaultNode(prop.propertyInfo.type);
                }
            }
            return n;
        case "map":
            return new Node_1.MapNode(sourceType, nodeType);
        case "union":
            const first = nodeType.resolveUnion()[0];
            return createDefaultNode(first);
        case "any":
        case "intersection":
        case "map":
        case "custom":
            return null;
    }
}
exports.createDefaultNode = createDefaultNode;
//# sourceMappingURL=createDefaultNode.js.map